import { BrowserRouter } from 'react-router';

import type { Meta, StoryFn } from '@storybook/react';
import type { ProgrammeCardProps } from './ProgrammeCard';

import { ProgrammeCard } from './ProgrammeCard';

import { Container } from 'storyComponents/Container';
import { Icon, Repeater } from 'components';

const codeString = '<ProgrammeCard key={key} header={header} details={details} href={href} isNew={boolean} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/ProgrammeCard',
  component: ProgrammeCard,
  parameters: {
    inspectComponent: ProgrammeCard,
    codeString: codeString,
  },
} as Meta<ProgrammeCardProps>;

const Template: StoryFn<ProgrammeCardProps> = (args) => (
  <BrowserRouter>
    <Container size="large">
      <ProgrammeCard {...args} />
    </Container>
  </BrowserRouter>
);

export const ProgrammeCardExample = Template.bind({});
ProgrammeCardExample.args = {
  header: 'This is our header',
  details: 'This is our details',
  href: '/',
};

export const WithComplexContent = Template.bind({});
WithComplexContent.args = {
  header: (
    <Repeater flexDirection="row" gap="150">
      <Icon name="Envelope" size={32} />
      <h2 style={{ margin: 0 }}>This is my header</h2>
    </Repeater>
  ),
  details: (
    <Repeater flexDirection="row" gap="150">
      <Repeater flexDirection="row">
        <Icon name="FaceFrown" />
        Details 1
      </Repeater>
      <Repeater flexDirection="row">
        <Icon name="Heart" />
        Details 2
      </Repeater>
      <Repeater flexDirection="row">
        <Icon name="Sparkles" />
        Details 3
      </Repeater>
    </Repeater>
  ),
  href: '/',
};

const MultiProgrammeCardsTemplate: StoryFn<ProgrammeCardProps> = (args) => (
  <BrowserRouter>
    <Container size="large">
      <Repeater>
        <ProgrammeCard {...args} />
        <ProgrammeCard {...args} />
        <ProgrammeCard {...args} />
      </Repeater>
    </Container>
  </BrowserRouter>
);

export const MultiProgrammeCards = MultiProgrammeCardsTemplate.bind({});
MultiProgrammeCards.args = {
  header: 'This is my header',
  details: 'This is my details',
  href: '/',
};
